// import axios from "axios";
import api from "../config/api";
import { LeaveTransaction } from "../types/LeaveTransaction";

const API_URL = "/leaveTransaction";

export const getLeaveTransactions = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getLeaveTransactionById = (id: number) =>
  api.get(`${API_URL}/?id=${id}`);

export const createLeaveTransaction = (data: LeaveTransaction) =>
  api.post(`${API_URL}/`, data);

export const updateLeaveTransaction = (id: number, data: LeaveTransaction) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteLeaveTransaction = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);

export const getEmpLeaveBal = (employeeId: string) =>
  api.get(`${API_URL}/balance/`, { params: { id: employeeId } }).then((res) => {
    return res.data.data;
  });
